import { render, staticRenderFns } from "./ehcSplash.vue?vue&type=template&id=ac58d9c0"
import script from "./ehcSplash.vue?vue&type=script&lang=js"
export * from "./ehcSplash.vue?vue&type=script&lang=js"
import style0 from "./ehcSplash.vue?vue&type=style&index=0&id=ac58d9c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports